import React from "react";
import { TextField, FormControl, Select, MenuItem, Switch, Typography, Button, Box, } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Ischools } from "../interfaces/interface";
import { getRequest } from "../functions/api_functions";
import CircularProgress from '@mui/material/CircularProgress';

// Tipo de resposta da API
type TypesResponse = {
    schools_type: number;
    type_description: string;
};

interface ChildComponentProps {
    school?: Ischools;
    onCallback?: (data: any) => void;
    onClose?: () => void;
};

const defaultSchool: Ischools = {
    school_cnpj: "",
    school_name: "",
    school_cep: "",
    school_board_email: "",
    school_link: "",
    school_type: 0,
    school_street: "",
    school_city: "",
    school_unit: "",
    school_neighborhood: "",
    link_active: true,
};

const SchoolForm: React.FC<ChildComponentProps> = ({ school, onCallback, onClose }) => {
    const [schoolTypes, setSchoolTypes] = React.useState<TypesResponse[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [schools, setSchools] = React.useState<Ischools>(school || defaultSchool);
    const [linkActive, setLinkActive] = React.useState<boolean>(schools.link_active ?? true);

    // Fetch para carregar os tipos de escola
    React.useEffect(() => {
        const fetchSchoolTypes = async () => {
            try {
                const response = await getRequest<{ status_code: number; types: TypesResponse[] }>("/get_all_types/");
                if (response.status_code === 200) {
                    setSchoolTypes(response.types);
                } else {
                    console.error("Erro ao buscar escolas.");
                }
            } catch (error) {
                console.error("Erro na requisição:", error);
            } finally {
                setLoading(false);
            }
        };
        setLoading(true);
        fetchSchoolTypes();
    }, []);

    React.useEffect(() => {
        if (onSubmit) {
            setOnSubmit(false)
            if (onCallback) {
                onCallback(schools)
            }
            if (onClose) {
                onClose();
            }
        };
    }, [schools])

    const handleSwitchChange = () => {
        setLinkActive(!linkActive);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setOnSubmit(true)
        const formData = new FormData(event.currentTarget);
        setSchools((school) => ({
            ...school,
            school_cnpj: formData.get("cnpj") as string || school.school_cnpj,
            school_name: formData.get("schoolName") as string || school.school_name,
            school_cep: formData.get("cep") as string || school.school_cep,
            school_board_email: formData.get("email") as string || school.school_board_email,
            school_link: formData.get("accessLink") as string || school.school_link,
            school_type: Number(formData.get("schoolType")) || school.school_type, // Converte para número
            school_street: formData.get("street") as string || school.school_street,
            school_city: formData.get("city") as string || school.school_city,
            school_unit: formData.get("unit") as string || school.school_unit,
            school_neighborhood: formData.get("district") as string || school.school_neighborhood,
            link_active: Boolean(linkActive),
        }))
        // if (onCallback) {
        //     console.log('Passando para o callback o valor de school:', schools);
        //     onCallback(schools)
        // }
        // if (onClose) {
        //     onClose();
        // }
    };

    return (
        <form onSubmit={handleSubmit}>
            {loading ? (
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={3}>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField slotProps={{ input: schools.school_cnpj ? { readOnly: true } : {}, }} required name="cnpj" label="CNPJ" fullWidth defaultValue={schools.school_cnpj} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField required name="schoolName" label="Nome da Escola" fullWidth defaultValue={schools.school_name} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField required name="email" label="E-mail" fullWidth defaultValue={schools.school_board_email} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField slotProps={{ input: { readOnly: true, },}} name="accessLink" label="Link de Acesso" fullWidth defaultValue={schools.school_link} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField required name="cep" label="CEP" fullWidth defaultValue={schools.school_cep} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField required name="street" label="Endereço" fullWidth defaultValue={schools.school_street} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <TextField required name="city" label="Cidade" fullWidth defaultValue={schools.school_city} />
                    </Grid>
                    <Grid size={{ xs:12, sm:3 }}>
                        <TextField required name="unit" label="UF" fullWidth defaultValue={schools.school_unit} />
                    </Grid>
                    <Grid size={{ xs:12, sm:3 }}>
                        <TextField required name="district" label="Bairro" fullWidth defaultValue={schools.school_neighborhood} />
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }}>
                        <FormControl fullWidth required>
                            <Select labelId="type-label" name="schoolType" defaultValue={schools.school_type || ""}>
                                {schoolTypes.map((type, index) => (
                                    <MenuItem key={index} value={type.schools_type}>{type.type_description}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs:12, sm:6 }} display="flex" alignItems="center">
                        <Switch name="link_active" checked={Boolean(linkActive)} onChange={handleSwitchChange} inputProps={{ "aria-label": "Link Ativo" }}/>
                        <Typography>Escola Ativa</Typography>
                    </Grid>
                    <Grid>
                        {schools.school_cnpj ? (
                            <Button type="submit" variant="contained" color="primary" fullWidth>Editar Escola</Button>
                        ):(
                            <Button type="submit" variant="contained" color="primary" fullWidth>Cadastrar Escola</Button>
                        )}
                    </Grid>
                </Grid>
            )}
        </form>
    );
};
export default SchoolForm;
